<template>
  <div id="header" class="row d-flex align-items-center">
    <div class="col-lg-4 col-md-5 col-sm-7">
      <router-link to="/services">
        <img src="/static/rd-images/logo.png" alt="Rychlý drát" id="logo"/>
      </router-link>
    </div>
    <div class="col-lg-4 col-md-2 col-sm-3">
      <div class="row">
        <div class="col item item-1">
          <nobr>
            <img src="/static/free-icons/phone.svg" width="30px">
            <a href="tel:+420212244400">212 244 400</a>
          </nobr>
        </div>
        <div class="col d-none d-sm-block item item-2">
          <nobr>
            <img src="/static/free-icons/envelope.svg" width="30px">
            <a href="http://www.rychlydrat.cz/kontakt" title="" target="_blank">Napište nám</a>
          </nobr>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-5 col-sm-12 item item-3 d-flex" v-if="$store.state.customerInfo">
      <img src="/static/free-icons/persona.svg" width="30px">
      <span>
        <div>{{ human_readable_name($store.state.customerInfo) }}</div>
        <div>{{ human_readable_address($store.state.customerInfo) }}</div>
        <div><abbr title="variabilní symbol pro platby">VS</abbr> {{ $store.state.customerInfo.id }}</div>
        <router-link to="/logout" title="">odhlásit</router-link>
      </span>
    </div>
	</div>
</template>

<script>
export default {
  name: 'rd-samoobsluha-header',
  methods: {
    human_readable_name: function (ci) {
      return ci.name + ' ' + ci.lastname + ' ' + (ci.bussinesname ? ci.bussinesname : '')
    },
    human_readable_address: function (ci) {
      let address = ci.a1_ulice ? ci.a1_ulice : ci.a1_obec
      address += ' ' + ci.a1_cislo
      address += ', ' + ci.a1_obec
      return address
    }
  }
}
</script>
<style scoped>
#header {
  margin: 0 auto;
  overflow: hidden;
  background: url(/static/rd-images/bg-header.png) 50% 100% no-repeat;
  padding-bottom: 0.25em;
}
#logo {
  border: none;
}
#header .item {
  font-size: 12px;
  padding: 0.25em 0.5em;
}
#customer-name {
  position: relative;
  top: 6px;
}
.item-1 {
  line-height: 29px;
}
.item-2 {
  text-transform: uppercase;
  line-height: 29px;
}
.item-3 img {
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// Header.vue?61035f52